import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaC_Hatchback_Left: React.FC<AreaSVGProps> = ({
  fill = '#FE6728',
  stroke = '#FE6728',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="106"
      height="182"
      viewBox="0 0 106 182"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_hatchback_left"
          x="0"
          y="0"
          width="106"
          height="182"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_c_hatchback_left)">
        <path
          d="M1.55762e-05 4.61655e-06C17.3265 5.10023 49.0285 11.9808 73.8731 11.2227C79.8974 11.1819 86.2788 9.64374 91.5352 7.30762L105.614 125.843L62.711 181.803L45.2598 172.02C50.0213 163.44 52.7868 153.157 53.1397 141.12L53.1406 141.103V141.085C53.4515 125.912 51.2907 110.936 41.5703 96.3467L41.5303 96.2871L41.4893 96.2295L40.7793 95.2549C37.1817 90.3802 32.826 85.4985 26.5293 81.3525C20.441 77.3438 12.7216 74.1425 2.41896 72.1504C2.39641 71.4631 2.37133 70.6689 2.34181 69.7715C2.22058 66.0856 2.04143 60.6499 1.80861 53.6504C1.37839 40.7163 0.764509 22.4421 1.55762e-05 4.61655e-06Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
